/** Compte technique POS — pas un client CRM (aligné backend caisseUtils) */
export const CAISSE_GUEST_EMAIL_PREFIX = 'caisse-invite+';
export const CAISSE_GUEST_EMAIL_DOMAIN = '@clickorico.internal';

export function isCaisseGuestClient(user) {
  if (!user) return false;
  const email = String(user.email || '').toLowerCase();
  if (
    email.startsWith(CAISSE_GUEST_EMAIL_PREFIX) &&
    email.endsWith(CAISSE_GUEST_EMAIL_DOMAIN)
  ) {
    return true;
  }
  const prenom = String(user.prenom || '').trim().toLowerCase();
  const nom = String(user.nom || '').trim().toLowerCase();
  return (
    prenom === 'comptoir' &&
    nom === 'client' &&
    email.includes('clickorico.internal')
  );
}

export function filterOutCaisseGuestClients(users) {
  if (!Array.isArray(users)) return [];
  return users.filter((u) => !isCaisseGuestClient(u));
}
